const isNullOrUndefined = (value) => value === null || value === undefined;

export default isNullOrUndefined;
